import { render } from "./DefaultComponent.vue?vue&type=template&id=47a1fdbf&scoped=true"
import script from "./DefaultComponent.vue?vue&type=script&lang=js"
export * from "./DefaultComponent.vue?vue&type=script&lang=js"

import "./DefaultComponent.vue?vue&type=style&index=0&id=47a1fdbf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a1fdbf"]])

export default __exports__